import api from "../api";

export interface LeaderboardEntry {
  rank: number;
  id: number;
  name: string;
  loyalty_points: number;
  loyalty_tier: string;
  is_top_rated: boolean;
  reputation_score: number;
}

export interface LeaderboardResponse {
  data: LeaderboardEntry[];
  current: LeaderboardEntry;
}

class LeaderboardService {
  async getLeaderboard(): Promise<LeaderboardResponse> {
    const response = await api.get<LeaderboardResponse>("/leaderboard");

    return response.data;
  }
}

export default new LeaderboardService();
